import { Content } from './source-icon.styled';

export const SourceIcon = ({ cntPayment, cntRack }) => {
  const getSourceType = () => {
    if (cntPayment && cntRack) {
      return <img src="/images/payment-and-rack.png" alt="" />;
    } else if (cntPayment) {
      return <img src="/images/payment_terminal.png" alt="" />;
    } else {
      return <img src="/images/single_rack.png" alt="" />;
    }
  };

  const type = getSourceType();
  return <Content>{type}</Content>;
};
